import React, { useCallback, useState } from 'react';
import { Typography } from '@wds/typography';
import { IconChevronDown, IconChevronUp } from '@wds/icons';
import usePricingFooterStyles from '~pricing/components/PricingFooter/useStyles';

type FAQAccordion = {
  heading: string;
  children: React.ReactNode;
  testid?: string;
};

export default function FAQ({ heading, children, testid }: FAQAccordion): JSX.Element {
  const [isActive, setIsActive] = useState(false);

  const { Accordion, AccordionContent, FAQHeading, Active, Inactive, Toggle } = usePricingFooterStyles();

  const handleClick = useCallback(() => {
    setIsActive(!isActive);
  }, [isActive]);

  return (
    <div className={`${Accordion} ${isActive ? Active : Inactive} `} data-testid={testid}>
      <button type="button" className={FAQHeading} onClick={handleClick} onKeyUp={handleClick} tabIndex={0}>
        <Typography variant="body" component="h5" data-testid="FAQ">
          {heading}
        </Typography>
        <span className={Toggle}>
          {isActive ? <IconChevronUp title="Up Arrow" /> : <IconChevronDown title="Down Arrow" />}
        </span>
      </button>
      <section className={AccordionContent}>{children}</section>
    </div>
  );
}
